module.exports = __webpack_public_path__ + "4761c5488f02dfbc7397cb07c5fa90ed.MP3";